import { render } from "./FooterMenu.vue?vue&type=template&id=08962b9a&scoped=true"
const script = {}

import "./FooterMenu.vue?vue&type=style&index=0&id=08962b9a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08962b9a"]])

export default __exports__